module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvYmFubmVyTG9hZGluZy5iOTRlN2ZiMi5wbmciOw=="